<ng-container *ngIf="isAdjustmentInvoice; else nonAdjustmentTemplate">

  <span *ngIf="isAdjustmentInvoice && (params.data.credit != null && params.data.credit != 0.0)"
    class="badge text-bg-info text-white" (click)="openAttachment(content, params)" style="cursor: pointer;">
    <i class="bi bi-eye"></i> View Credit Note
  </span>
  <span
    *ngIf="isAdjustmentInvoice && (params.data.debit != null && params.data.debit != 0.0) && (params.data.credit == null || params.data.credit == 0.0)"
    class="badge text-bg-info text-white" (click)="openAttachment(content, params)" style="cursor: pointer;">
    <i class="bi bi-eye"></i> View Invoice
  </span>

</ng-container>

<ng-template #nonAdjustmentTemplate>
  <ng-container *ngIf="isManifestPodMode; else defaultPodTemplate">
    <div *ngIf="showManifestAvailable" class="manifest-pod-cell">
      <button type="button" class="manifest-pod-action" (click)="openAttachment(content, params)">
        <span class="manifest-pod-label manifest-pod-label--available">Available</span>
        <i class="bi bi-eye-fill manifest-pod-icon" aria-hidden="true"></i>
      </button>
    </div>

    <div *ngIf="showManifestUnavailable" class="manifest-pod-cell">
      <span class="manifest-pod-label manifest-pod-label--unavailable">Not Available</span>
    </div>
  </ng-container>
</ng-template>

<ng-template #defaultPodTemplate>

  <span *ngIf="normalizedValue && bookingId" class="badge text-bg-info text-white" (click)="openAttachment(content, params)"
    style="cursor: pointer;">
    <i class="bi bi-eye"></i> View
  </span>

  <div *ngIf="!normalizedValue || !bookingId">
    <ng-container *ngIf="showNotice; else elseTemplate">
      <div class="d-flex align-items-center">
        <i class="bi bi-exclamation-lg text-danger fs-3"></i>
        <span class="badge bg-primary text-white" style="cursor: not-allowed; opacity: 0.6;">
          <i class="bi bi-eye"></i> View
        </span>
      </div>
    </ng-container>
    <ng-template #elseTemplate>
      <span class="badge bg-primary text-white" style="cursor: not-allowed; opacity: 0.6;">
        <i class="bi bi-eye"></i> View
      </span>
    </ng-template>
  </div>

</ng-template>



<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title">
      <ng-container *ngIf="isAdjustmentInvoice; else elseChangeTitle">
        View Attachment ( Adjusment Invoice ID: <span class="fw-bold ">{{ titleModal }}</span> )
      </ng-container>
      <ng-template #elseChangeTitle>
        Proof of Delivery ( Booking ID: <span class="fw-bold ">{{ titleModal }}</span> )
      </ng-template>
    </h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body d-flex align-items-center justify-content-center" style="height: 1000px !important;">
    <ng2-pdfjs-viewer [pdfSrc]="pdfSrc" class="w-100 h-100"></ng2-pdfjs-viewer>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary text-white" (click)="modal.close('Close click')">Close</button>
  </div>
</ng-template>


<div *ngIf="value == null && showNotice">
  <i class="bi bi-exclamation-lg text-danger fs-3"></i>
</div>
